module.exports = __webpack_public_path__ + "images/category_lp/trading_card/assessment_achievements/2@2x_39d02dd63a42c8161946dda2b1e23b8a.png";